<template>
  <Banner :textMessage="$t(text)"></Banner>
</template>
<script>
import Banner from './Banner.vue';
import { constantStrings } from '@/services/constants'

export default {
  components: {
    Banner
  },
  data() {
    return {
      text: constantStrings.OFFLINE_BANNER_TEXT
    }
  }
}
</script>
